import { FC, useEffect, useRef } from 'react';
import { YMInitializer } from 'react-yandex-metrika';

import { useAppSelector, useUserFunctionality } from 'hooks';
import { configSelector, metrikaRoleSelector, userLocalRolesSelector } from 'selectors';

import { emitYMEvent } from '../../utils/emitYMEvent';
import { getYandexMetrikaCode } from '../../utils/yandexMetrika';

const YandexMetrika: FC = () => {
  const localRoles = useAppSelector(userLocalRolesSelector);
  const user = useUserFunctionality();
  const initiallyLoaded = useRef(false);
  const metrikaRole = useAppSelector(metrikaRoleSelector);
  const aupdId = useAppSelector((state) => state.currentUser.data?.aupdId);
  const config = useAppSelector(configSelector);

  const userParams = metrikaRole
    ? {
        role: metrikaRole,
        sub: aupdId,
      }
    : undefined;
  const accounts = getYandexMetrikaCode(user, localRoles, config?.MODE);
  const isYmDisabled = user.isAdmin || !config || config.YM_ENABLED === false;

  useEffect(() => {
    if (!initiallyLoaded.current && aupdId && metrikaRole && !isYmDisabled) {
      // Вызывает событие openService через 1.5 секунды, когда яндекс метрика будет инициализирована
      const tmId = setTimeout(() => {
        emitYMEvent({
          type: 'openService',
          payload: {
            sub: aupdId,
            role: metrikaRole,
          },
        });
        initiallyLoaded.current = true;
      }, 1500);

      return () => {
        clearTimeout(tmId);
      };
    }
  }, [aupdId, metrikaRole, isYmDisabled]);

  return isYmDisabled ? null : (
    <YMInitializer
      accounts={accounts}
      options={{
        clickmap: true,
        trackLinks: true,
        accurateTrackBounce: true,
        userParams,
      }}
    />
  );
};

export default YandexMetrika;
